(function (ws) {
    'use strict';

    ws.views.ShipToVatModal = ws.views.modal.extend({

        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .ship-from-help-submit': 'shipFromSubmit',
            'click .ship-from-help-cancel': 'cancelModal'
        }),

        /**
         * Initialize
         */
        initialize: function() {
            ws.views.modal.prototype.initialize.call(this);
        },

        shipFromSubmit: function(e) {
            console.log('submit');
        },

        cancelModal: function(e) {
            console.log('close');

            //this.eventAgg.trigger('shipFromHelpModal' + 'close');
            ws.views.modal.prototype.closeModal.call(this);
        }
    });
})(westcon);
